// eslint-disable-next-line jira/filename-case
import React, { type ReactNode } from 'react';
import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';
import { ErrorBoundaryWithChunkErrorLogging } from '@jira/platform__onboarding-core/src/ui/error-boundary-with-chunk-error-logging/index.tsx';
import { PACKAGE_NAME } from '../../constants.tsx';

export const OnboardingNudgeErrorBoundary = (props: {
	id: string;
	attributes: AnalyticsAttributes;
	fallback: ReactNode;
	children: ReactNode;
}): React.JSX.Element => {
	const { id, attributes, fallback, children } = props;

	return (
		<ErrorBoundaryWithChunkErrorLogging
			id={id}
			packageName={PACKAGE_NAME}
			render={() => fallback}
			attributes={attributes}
		>
			{children}
		</ErrorBoundaryWithChunkErrorLogging>
	);
};
